import { DataTableColumn } from "../../data-table.config";
import { AccessAction } from 'src/app/layouts/main-layout/components/sidebar/config/access-control.config';

export class DataTableColumnActionsButton {
    icon!: string;
    tooltip?: string
    onClick?: (item: any) => void;
    isDelete?: boolean;
    hidden?: (item: any) => any;
    aclAction?: AccessAction;
}

export class DataTableColumnActions extends DataTableColumn {
    buttons!: DataTableColumnActionsButton[];

    constructor(params : any)
    {
        super();
        Object.assign(this, params);
    }
}
